import { Checkbox, Stack } from "@chakra-ui/react";
import React from "react";

const Checklist = ({ field, values }) => {
  return (
    <Stack>
      {field.options.map((option) => (
        <>
          <Checkbox
            key={option}
            isChecked={values[`${field.id}`]?.includes(option)}
            className={`${!field.chosen.includes(option) ? "disabled" : ""}`}
            checked={!field.chosen.includes(option)}
          >
            {option}
          </Checkbox>
        </>
      ))}
    </Stack>
  );
};

export default Checklist;
